import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

const PostDetail = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [recentPosts, setRecentPosts] = useState([]);

  const fetchPost = async () => {
    try {
      const response = await fetch(`https://interprika.com/cms/wp-json/wp/v2/posts/${id}?_embed`);
      const postData = await response.json();
      setPost(postData);

      const recentPostsResponse = await fetch('https://interprika.com/cms/wp-json/wp/v2/posts?_embed');
      const recentData = await recentPostsResponse.json();

      const filteredPosts = recentData.filter(post => post.id !== parseInt(id)).slice(0, 4);
      setRecentPosts(filteredPosts);

    } catch (error) {
      console.error('Error fetching post:', error);
    }
  };

  useEffect(() => {
    fetchPost();
  }, [id]);

  if (!post) {
    return (
      <div className='w-full h-full bg-black fixed top-0 z-[999999999] flex flex-col justify-center items-center'>
        <img className='w-[300px] max-md:w-[150px] h-[44px] object-contain' src='./images/logo.png' alt="" />
      </div>
    );
  }

  return (
    <div>
      {/* ✅ SOLO CSS para interpretar contenido WP (listas incluidas) */}
      <style>{`
        .wp-content {
          font-size: 16px;
          line-height: 1.75;
        }

        .wp-content p { margin: 0 0 1rem; }
        .wp-content strong { font-weight: 700; }
        .wp-content em { font-style: italic; }
        .wp-content del { text-decoration: line-through; }

        .wp-content h1 {
          font-size: 2rem;
          line-height: 2.2rem;
          font-weight: 700;
          margin: 1.5rem 0 1rem;
        }
        .wp-content h2 {
          font-size: 1.5rem;
          line-height: 1.9rem;
          font-weight: 700;
          margin: 1.25rem 0 0.75rem;
        }
        .wp-content h3 {
          font-size: 1.25rem;
          font-weight: 700;
          margin: 1rem 0 0.5rem;
        }

        /* ✅ LISTAS: fuerza bullets/números aunque Tailwind/Reset los quite */
        .wp-content ul {
          list-style-type: disc !important;
          list-style-position: outside;
          margin: 0 0 1rem;
          padding-left: 1.5rem;
        }

        .wp-content ol {
          list-style-type: decimal !important;
          list-style-position: outside;
          margin: 0 0 1rem;
          padding-left: 1.5rem;
        }

        .wp-content li {
          display: list-item !important;
          margin: 0.25rem 0;
        }

        /* Listas anidadas */
        .wp-content li > ul,
        .wp-content li > ol {
          margin-top: 0.5rem;
          margin-bottom: 0.5rem;
          padding-left: 1.25rem;
        }

        .wp-content ul ul { list-style-type: circle !important; }
        .wp-content ul ul ul { list-style-type: square !important; }
        .wp-content ol ol { list-style-type: lower-alpha !important; }

        .wp-content blockquote {
          margin: 1.25rem 0;
          padding: 0.75rem 1rem;
          border-left: 4px solid #F89D38;
          background: rgba(248, 157, 56, 0.08);
        }
        .wp-content blockquote p { margin: 0; }

        .wp-content hr {
          margin: 1.5rem 0;
          border: 0;
          border-top: 1px solid rgba(0,0,0,0.15);
        }

        .wp-content img {
          max-width: 100%;
          height: auto;
          display: block;
        }

        .wp-content img.alignleft { float: left; margin: 0.25rem 1rem 1rem 0; }
        .wp-content img.alignright { float: right; margin: 0.25rem 0 1rem 1rem; }
        .wp-content img.aligncenter { margin-left: auto; margin-right: auto; }

        .wp-content::after {
          content: "";
          display: block;
          clear: both;
        }
      `}</style>

      <div className='w-[1280px] 2xl:w-[1440px] max-w-full px-[30px] lg:px-[100px] mx-auto'>
        <div className='flex flex-col lg:flex-row relative items-center'>
          <div className="w-full py-5 pr-5 mt-6 mb-20">
            <div className="w-full h-[400px] bg-gray-300 mb-4">
              {post._embedded['wp:featuredmedia'] && (
                <img
                  src={post._embedded['wp:featuredmedia'][0].source_url}
                  alt={post.title.rendered}
                  className="object-cover w-full h-full"
                />
              )}
            </div>

            <div className="flex justify-between items-center text-gray-500 mb-4">
              <span>{new Date(post.date).toLocaleDateString()}</span>
              <span>{Math.ceil(post.content.rendered.split(' ').length / 200)} min de lectura</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row relative">
          <div className="w-full lg:w-3/4 pb-5 border-r">
            <h1 className="text-3xl font-bold mt-[-70px] mb-10">{post.title.rendered}</h1>

            {/* ✅ wrapper wp-content para aplicar estilos del editor */}
            <div
              className="wp-content [&_*]:max-w-full [&_img]:max-w-full md:pr-4"
              dangerouslySetInnerHTML={{ __html: post.content.rendered }}
            />
          </div>

          <div className="w-full lg:w-1/4 pt-4 md:p-4 sticky md:top-[140px] h-[400px]">
            <h3 className="md:mt-[-80px] mb-12 text-right bg-black text-white border border-black transition-all duration-500 hover:bg-white hover:text-black p-1 px-3">
              Últimos <span className='font-bold'>Artículos</span>
            </h3>

            {recentPosts.map(post => (
              <div key={post.id} className="mb-4">
                <Link to={`/blog/${post.id}`} className='flex items-center'>
                  <div className="flex-shrink-0 w-[60px] h-[60px] bg-gray-300 rounded"></div>
                  <div className="ml-4">
                    <h4 className="text-sm font-medium uppercase">{post.title.rendered}</h4>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostDetail;